import OneSignalError from "./OneSignalError";
export var OneSignalApiErrorKind;
(function (OneSignalApiErrorKind) {
    OneSignalApiErrorKind[OneSignalApiErrorKind["MissingAppId"] = 0] = "MissingAppId";
})(OneSignalApiErrorKind || (OneSignalApiErrorKind = {}));
export class OneSignalApiError extends OneSignalError {
    constructor(reason) {
        switch (reason) {
            case OneSignalApiErrorKind.MissingAppId:
                super('The API call is missing an app ID.');
                break;
        }
    }
}
//# sourceMappingURL=OneSignalApiError.js.map